/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () => import(/* webpackChunkName: '' */ `./components/${path}`).then(m => m.default || m)

export const routes = [
    {
        path: '/configuracion/materiales',
        name: 'Materiales',
        component: page('MaterialList'),
    },
    {
        path: '/materiales/:id',
        name: 'Ver Material',
        component: page('MaterialView'),
        hidden: true
    }
]
